import type {
    CurrencyCode} from "@@/shared/currencies/currencies";
import {
    currencyCodeZodSchema,
} from "@@/shared/currencies/currencies";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    OrderGroupId} from "@@/shared/order-groups/order-group-id";
import {
    orderGroupIdZodSchema,
} from "@@/shared/order-groups/order-group-id";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import { z } from "zod";
import type { UserId} from "../../users/user-id";
import { userIdZodSchema } from "../../users/user-id";
import type { PaymentId} from "../payment-id";
import { paymentIdFactory, paymentIdZodSchema } from "../payment-id";
import type {
    PaymentProvider} from "../payment-providers";
import {
    paymentProviderZodSchema,
} from "../payment-providers";

type FreePaymentFulfilled = {
    _id: PaymentId;
    _type: "FREE_PAYMENT";
    status: "FULFILLED";
    orderTotalWithoutDiscount: Price;
    discounted: boolean;
    _createdAt: IsoAndUnixTimestamp;
    currencyCode: CurrencyCode;
    orderGroupId: OrderGroupId;
    paymentProvider: PaymentProvider;
    userId: UserId;
};

const freePaymentFulfilledFactory = (
    params: Omit<
        FreePaymentFulfilled,
        "_id" | "_type" | "status" | "_createdAt"
    >,
) => {
    const payment: FreePaymentFulfilled = {
        ...params,
        _id: paymentIdFactory(),
        _type: "FREE_PAYMENT",
        status: "FULFILLED",
        _createdAt: nowIsoAndUnix(),
    };

    return payment;
};

const freePaymentFulfilledZodSchema: z.ZodSchema<FreePaymentFulfilled> =
    z.object({
        _id: paymentIdZodSchema,
        _type: z.literal("FREE_PAYMENT"),
        _createdAt: isoAndUnixZodSchema,
        status: z.literal("FULFILLED"),
        orderTotalWithoutDiscount: priceZodSchema,
        discounted: z.boolean(),
        currencyCode: currencyCodeZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        paymentProvider: paymentProviderZodSchema,
        userId: userIdZodSchema,
    });

export { freePaymentFulfilledFactory, freePaymentFulfilledZodSchema };
export type { FreePaymentFulfilled };
